export default "<style>\n    .wrapper {\n        background-color: transparent!important\n    }\n\n</style>\n<logout-widget></logout-widget>";